import { Input } from "../../core/Input";
import { TInputNumberProps } from "./index";

export default function InputNumber({
  register,
  required,
  error,
  style,
  label,
  nameInput,
  onChange,
  readOnly
}: TInputNumberProps) {
  return (
    <Input
      type="number"
      label={label}
      fieldName={nameInput}
      register={register}
      required={required}
      error={error?.[nameInput]}
      style={style}
      onChange={onChange}
      readOnly={readOnly}
    />
  );
}
